import {Component, OnInit, ViewChild} from '@angular/core';
import {VoucherOrder} from './../../../dto/voucher-order';
import {Product} from '../../../dto/product';
import {AbstractControl, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {ProductService} from './../../services/product.service';
import {VoucherOrdersService} from '../../services/voucherOrders.service';
import {Location} from '@angular/common';
import {DateEditComponent} from '../../../shared/date-edit/date-edit.component';
import {DateFormats} from '../../../providers/app-date-adapter';
import {VoucherType} from '../../../dto/voucherType';

@Component({
  selector: 'app-voucher-order-add',
  templateUrl: './voucher-order-add.component.html',
  styleUrls: ['./voucher-order-add.component.css']
})
export class VoucherOrderAddComponent implements OnInit {
  @ViewChild('expireDate', { static: false }) dateEdit: DateEditComponent;
  orderMinDate: Date;
  orderMaxDate: Date;
  company: VoucherOrder;
  products: Product[];
  voucherTypes: any;
  voucherOrderForm: FormGroup;

  constructor(private router: Router,
    private productService: ProductService,
    private voucherOrdersService: VoucherOrdersService,
    private formBuilder: FormBuilder,
    private location: Location,
  ) { }

  ngOnInit() {
    this.orderMinDate = new Date();
    this.orderMaxDate = new Date();
    this.orderMinDate.setHours(0, 0, 0, 0);
    this.orderMaxDate.setHours(0, 0, 0, 0);
    this.orderMaxDate.setFullYear(this.orderMaxDate.getFullYear() + 2);

    this.voucherTypes = [
      { code: VoucherType.fullAmount, name: 'Full amount' },
      { code: VoucherType.fixedAmount, name: 'Fixed amount' },
      // { code: VoucherType.fullAmount, name: "Fixed Rate" }
    ];

      this.initForm({
        productId: null,
        startDate: new Date(),
        expireDate: null,
        quantity: 1,
        voucherCodes: [],
        voucherType: VoucherType.fullAmount,
        fixedAmount: 0,
        fixedRate: 0.1,
        packageName: null,
      } as VoucherOrder);
      this.productService.getAll().subscribe(x => {
        this.products = x.data;
      });

    this.voucherOrderForm.get('voucherType').valueChanges
      .subscribe(value => {
        this.voucherOrderForm.get('fixedAmount').updateValueAndValidity();
      });

  }

  fixedAmountConditionalValidator(formControl: AbstractControl) {
    if (!formControl.parent) {
      return null;
    }

    if (formControl.parent.get('voucherType').value === 1) {
      if ( !formControl.value ) {
        return { required: true };
      }

      if ( formControl.value < 1 ) {
return { too_low: true };
}
      if ( formControl.value > 200 ) {
return { too_high: true };
}

    }
    return null;
  }

  initForm(order: VoucherOrder) {
    this.voucherOrderForm = this.formBuilder.group({
      productId: order.productId,
      startDate: order.startDate,
      expireDate: order.expireDate,
      quantity: order.quantity,
      voucherCodes: order.voucherCodes,
      voucherType: order.voucherType,
      fixedAmount: new FormControl(order.fixedAmount, [
        this.fixedAmountConditionalValidator
      ]),
      packageName: order.packageName,
      fixedRate: order.fixedRate,
    });
  }
  returnBack() {
    this.location.back();
  }



  newDateBoundaries(date: any) {
    this.dateEdit.min = new Date(date);
    this.dateEdit.max = new Date(date);
    this.dateEdit.max.setUTCFullYear(this.dateEdit.max.getUTCFullYear() + 2);
    this.dateEdit.writeValue(date.format(DateFormats.MomentForSendFormat));
    this.dateEdit.change();
  }
  onSubmit(form: FormGroup) {
    this.voucherOrdersService.add(form.value)
    .subscribe(res => this.returnBack());
  }
}
